export const setZero = (value: number): string => {
  const str = `${value}`;
  if (str.length === 1) return `0${str}`;
  return str;
};
